import { AnswerTemplate } from './../../../_models/answerTemplate';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from './../../../_services/admin.service';
import { Component, OnInit } from '@angular/core';
import Swal  from 'sweetalert2';
declare var $ : any;
@Component({
  selector: 'app-answer-template-show',
  templateUrl: './answer-template-show.component.html',
  styleUrls: ['./answer-template-show.component.css']
})
export class AnswerTemplateShowComponent implements OnInit {
  answerTemplate:AnswerTemplate=undefined
  server_answer_template_id=undefined
  constructor(
    private adminService:AdminService,
    private route:ActivatedRoute,
    private router:Router
  ) { }

  ngOnInit(): void {
  this.route.params.subscribe(
    params=>{
      this.server_answer_template_id = +params['server_answer_template_id']
      if(this.server_answer_template_id){
        this.reloadTemplate()
      }
    }
  )
  }


  deleteTemplate(){
    this.adminService.deleteAnswerTemplateById(this.answerTemplate.server_answer_template_id).subscribe(
      val=>{
        let msg=""

        if(val=="success"){
          this.router.navigate(["/answer/template/index"])
          msg="Yes! Deleted"
        }else{
          msg="Nope!"
        }
        this.alertOnDelete(msg)
      }
    )

  }
  templateRename(){
      $("#renameAnswerTemplateModal").modal("show");
    }
    reloadTemplate(){
      this.adminService.getAnswerTemplateById(this.server_answer_template_id).subscribe(
        val=>{
          this.answerTemplate=val
        }
      )
    }

  alertOnDelete(msg:String){
    Swal.fire({
    title: '<strong>Delete Answer Template</strong>',
    icon: 'info',
    html: ""+msg,
    showCloseButton: true,
    allowOutsideClick: false,
    focusConfirm: true,
    confirmButtonText:'Close',
    confirmButtonAriaLabel: 'Close'
  })
}
}
